<div class="container">
   <div *ngIf="isLoading" class="row center">
      <div class="spinner-border text-danger" role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div *ngIf="!isLoading" class="row">
      <div class="col-lg-12 col-md-12 col-xs-12">
         <div class="form-inline">
            <div class="form-group">
               <div class="col-lg-4 col-md-6 col-xs-2">
                  <label for="sel1">Source</label>
               </div>
               <div class="col-lg-6 col-md-6 col-xs-6">
                  <select class="form-control" id="odds">
                     <!--option [selected]="matchData.oddsProvider == 'Auto'" value="Auto">Auto</option>
                      <option [selected]="matchData.oddsProvider == 'Alwa'" value="Alwa">ALWAR</option-->
                     <!-- <option [selected]="matchData.oddsProvider == 'diamond'" value="diamond">Diamond</option> -->
                     <option [selected]="matchData.oddsProvider == 'neeraj'" value="neeraj">Betfair</option>
                     <!-- <option [selected]="matchData.oddsProvider == 'sky'" value="sky">Sky</option>
                     <option [selected]="matchData.oddsProvider == 'world'" value='world'>World</option> -->
                     <!-- <option [selected]="matchData.oddsProvider == 'ar'" value='ar'>AR</option> -->
                  </select>
               </div>
            </div>
            <button (click)="updateOdds(matchData.eventId)" class="btn btn-success btn-sm">Update Odds</button>
         </div>
      </div>
      <div class="col-md-12 col-xs-12 mtop">
         <div class="">
            <div *ngIf="isLoadingO" class="col-md-4 col-xs-12">
               <div class="row center loader">
                  <div class="spinner-border text-danger" role="status">
                     <span class="sr-only">Loading...</span>
                  </div>
               </div>
            </div>
            <div *ngIf="oddsType == 'Neeraj'" class="col-md-4 col-xs-12">
               <p>Betfair [ {{ oddsData?.status }} ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData?.runners">
                        <th class="center">{{ selectionName(run.selectionId)[0]?.name }}</th>
                        <th class="back center">
                           <div class="">{{ run.ex.availableToBack[0]?.price }}</div>
                           <div class="size">{{ run.ex.availableToBack[0]?.size }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.ex.availableToLay[0]?.price }}</div>
                           <div class="size">{{ run.ex.availableToLay[0]?.size }}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div *ngIf="isLoadingS" class="col-md-4 col-xs-12">
               <div class="row center loader">
                  <div class="spinner-border text-danger" role="status">
                     <span class="sr-only">Loading...</span>
                  </div>
               </div>
            </div>
            <div *ngIf="oddsType == 'Sky'" class="col-md-4 col-xs-12">
               <p>Sky Exchange [ OPEN ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData">
                        <th class="center">{{ selectionName(run.selectionId)[0]?.name }}</th>
                        <th class="back center">
                           <div class="">{{ run.availableToBack[0]?.price }}</div>
                           <div class="size">{{ run.availableToBack[0]?.size }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.availableToLay[0]?.price }}</div>
                           <div class="size">{{ run.availableToLay[0]?.size }}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div *ngIf="isLoadingC" class="col-md-4 col-xs-12">
               <div class="row center loader">
                  <div class="spinner-border text-danger" role="status">
                     <span class="sr-only">Loading...</span>
                  </div>
               </div>
            </div>
            <div *ngIf="oddsType == 'Tree'" class="col-md-4 col-xs-12">
               <p>Tree [ {{ oddsData?.odds?.status }} ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData?.odds?.runners">
                        <th class="center">{{ selectionName(run.selectionId)[0]?.name }}</th>
                        <th class="back center">
                           <div class="">{{ run.ex.availableToBack[0]?.price }}</div>
                           <div class="size">{{ run.ex.availableToBack[0]?.size }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.ex.availableToLay[0]?.price }}</div>
                           <div class="size">{{ run.ex.availableToLay[0]?.size }}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div *ngIf="oddsType == 'Diamond'" class="col-md-4 col-xs-12">
               <p>Diamond [ {{ oddsData[0]?.mstatus }} ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData">
                        <th class="center">{{ selectionName(run.sid)[0]?.name }}</th>
                        <th class="back center">
                           <div class="">{{ run.b1 }}</div>
                           <div class="size">{{ run.bs1 }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.l1 }}</div>
                           <div class="size">{{ run.ls1 }}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div *ngIf="oddsType == 'Ar'" class="col-md-4 col-xs-12">
               <p>AR [ {{ oddsData?.status }} ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData?.runners">
                        <th class="center">{{ selectionName(run.selectionId)[0]?.name }}</th>
                        <th class="back center">
                           <div class="">{{ run.exchanges.availableToBack[0]?.price }}</div>
                           <div class="size">{{ run.exchanges.availableToBack[0]?.size }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.exchanges.availableToLay[0]?.price }}</div>
                           <div class="size">{{ run.exchanges.availableToLay[0]?.size }}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div *ngIf="oddsType == 'World'" class="col-md-4 col-xs-12">
               <p>World [ {{ oddsData?.status | uppercase}} ]</p>
               <table class="table table-bordered table-sm mtop">
                  <thead>
                     <tr>
                        <th class="center">Runner</th>
                        <th class="back center">BACK</th>
                        <th class="lay center">LAY</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let run of oddsData?.section">
                        <th class="center">{{ run.nat }}</th>
                        <th class="back center">
                           <div class="">{{ run.odds[2]?.odds }}</div>
                           <div class="size">{{ run.odds[2]?.size }}</div>
                        </th>
                        <th class="lay center">
                           <div class="">{{ run.odds[3]?.odds }}</div>
                           <div class="size">{{ run.odds[3]?.size}}</div>
                        </th>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
      <div class="col-lg-12 col-md-12 col-xs-12">
         <div class="col-md-12 col-xs-12">
            <h2>All Fancy for {{ matchData.eventName }}</h2>
         </div>
         <div class="col-md-12 col-xs-12">
            <button id="all" (click)="getFancyByStatus('All', 'all')" class="btn btn-success tab">New Fancies</button>
            <button id="inactive" (click)="getFancyByStatus('Inactive', 'inactive')"
               class="btn btn-primary tab">Inactive</button>
            <button id="active" (click)="getFancyByStatus('Active', 'active')"
               class="btn btn-primary tab">Active</button>
            <button id="close" (click)="getFancyByStatus('Closed', 'close')" class="btn btn-primary tab">Close</button>
            <button id="remove" (click)="getFancyByStatus('Removed', 'remove')"
               class="btn btn-primary tab">Removed</button>
            <a routerLink="/home" class="btn btn-danger">Show Events</a>
            <!--button id="getManualFancy" data-toggle="modal" data-target="#myModal"
               (click)="getWBTManualFancy(matchData.eventId)" class="btn btn-info tab">Show
               Manual Fancy</button-->
         </div>
         <div class="col-md-4 col-xs-12 mtop">
            <input (keyup)="searchFancy($event)" type="text" id="search" class="form-control "
               placeholder="Fancy search">
         </div>
         <div class="col-md-4 col-xs-12 mtop">
            <button *ngIf="operation == 'All'" (click)="insertAllFancy('Active', adata)" class="btn btn-primary">Active
               All</button>
            <button *ngIf="operation == 'Inactive'" (click)="updateAllFancy('Active')" class="btn btn-primary">Active
               All</button>
            <button *ngIf="operation == 'Active'" (click)="updateAllFancy('Inactive')" class="btn btn-primary">Inactive
               All</button>
         </div>
         <div class="col-md-12 col-xs-12 mtop">
            <h3>Auto Fancy</h3>
         </div>
         <div class="col-md-12 col-xs-12 mtop">
            <div class="table-responsive">
               <table class="table table-bordered">
                  <thead>
                     <tr>
                        <th>#</th>
                        <th>Fancy Name</th>
                        <th *ngIf="fancyProvider == 'diamond' || fancyProvider == 'bull'">Fancy Type</th>
                        <th class="layyes">No</th>
                        <th class="backno">Yes</th>
                        <th>Action</th>
                        <th>Activities</th>
                     </tr>
                  </thead>
                  <tbody *ngIf="fancyProvider == 'diamond'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.nat }}</td>
                        <td>{{ afancy.gtype }}</td>
                        <td *ngIf="afancy.gstatus != ''" colspan="2" class="ballR">Ball Running</td>
                        <td *ngIf="afancy.gstatus == ''" class="layyes">{{ afancy.l1 }} <br> {{ afancy.ls1 }}</td>
                        <td *ngIf="afancy.gstatus == ''" class="backno">{{ afancy.b1 }} <br> {{ afancy.bs1 }}</td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.sid+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'sky'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.marketName }}</td>
                        <td *ngIf="afancy.status == '6' || afancy.status == '10'" colspan="2" class="ballR">Ball Running
                        </td>
                        <td *ngIf="afancy.status == '2'" class="layyes">{{ afancy.runsNo }} <br> {{ afancy.oddsNo }}
                        </td>
                        <td *ngIf="afancy.status == '2'" class="backno">{{ afancy.runsYes }} <br> {{ afancy.oddsYes }}
                        </td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.marketName, afancy.marketId, 'sky', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.marketName, afancy.marketId, 'sky', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.marketName, afancy.marketId, 'sky', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.selectionId, afancy.marketName)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.marketName, afancy.marketId, 'sky', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.marketId+'.FY', afancy.selectionId, afancy.marketName)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.marketId"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.marketId+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.marketId"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'sk'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.runner_name }}</td>
                        <td *ngIf="afancy.is_sus" colspan="2" class="ballR">Ball Running
                        </td>
                        <td *ngIf="!afancy.is_sus" class="layyes">{{ afancy.no_odd }} <br> {{ afancy.no_bhav }}
                        </td>
                        <td *ngIf="!afancy.is_sus" class="backno">{{ afancy.yes_odd }} <br> {{ afancy.yes_bhav }}
                        </td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.runner_name, afancy.sky_fancy_id, 'sk', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.runner_name, afancy.sky_fancy_id, 'sk', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.runner_name, afancy.sky_fancy_id, 'sk', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.selectionId, afancy.runner_name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.runner_name, afancy.sky_fancy_id, 'sk', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY', afancy.selectionId, afancy.runner_name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed'">
                           <button (click)="rollbackPopup(matchData.eventId, afancy.selectionId)"
                              class="btn btn-danger">Rollback</button>
                        </td>
                        <td *ngIf="operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.sky_fancy_id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.sky_fancy_id+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.sky_fancy_id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'tree'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.headname }}</td>
                        <td *ngIf="afancy.DisplayMsg == 'Ball Running' || afancy.DisplayMsg == 'BALL RUNNING' || afancy.DisplayMsg == 'SUSPENDED'"
                           colspan="2" class="ballR">{{ afancy.DisplayMsg }} {{ afancy.group }}</td>
                        <td *ngIf="afancy.DisplayMsg != 'Ball Running' && afancy.DisplayMsg != 'BALL RUNNING' && afancy.DisplayMsg != 'SUSPENDED'"
                           class="layyes">{{ afancy.SessInptYes }} {{ afancy.group }} <br> {{ afancy.YesValume }}</td>
                        <td *ngIf="afancy.DisplayMsg != 'Ball Running' && afancy.DisplayMsg != 'BALL RUNNING' && afancy.DisplayMsg != 'SUSPENDED'"
                           class="backno">{{ afancy.SessInptNo }} {{ afancy.group }} <br> {{ afancy.NoValume }}</td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'diamond', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.sid+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'neeraj'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.RunnerName }}</td>
                        <td *ngIf="afancy.GameStatus != ''" colspan="2" class="ballR">Ball Running
                        </td>
                        <td *ngIf="afancy.GameStatus == ''" class="layyes">{{ afancy.LayPrice1 }} <br>
                           {{ afancy.LaySize1 }}
                        </td>
                        <td *ngIf="afancy.GameStatus == ''" class="backno">{{ afancy.BackPrice1 }} <br>
                           {{ afancy.BackSize1 }}
                        </td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.RunnerName, afancy.SelectionId, 'neeraj', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.RunnerName, afancy.SelectionId, 'neeraj', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.RunnerName, afancy.SelectionId, 'neeraj', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.selectionId, afancy.RunnerName)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.RunnerName, afancy.SelectionId, 'neeraj', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.SelectionId+'.FY', afancy.selectionId, afancy.RunnerName)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.SelectionId"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.SelectionId+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.SelectionId"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'world'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.nat }}</td>
                        <td *ngIf="afancy.gstatus != ''" colspan="2" class="ballR">Ball Running</td>
                        <td *ngIf="afancy.gstatus == ''" class="layyes">{{ afancy.odds[1]?.odds || afancy.l1 }} <br> {{
                           afancy.odds[1]?.size || afancy.ls1 }}</td>
                        <td *ngIf="afancy.gstatus == ''" class="backno">{{ afancy.odds[0]?.odds || afancy.b1 }} <br> {{
                           afancy.odds[0]?.size || afancy.bs1 }}</td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'world', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'world', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'world', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.nat, afancy.sid, 'world', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.sid+'.FY', afancy.selectionId, afancy.nat)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.sid+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.sid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'bull'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.runner_name }}</td>
                        <td>{{ fcType(afancy.fancy_market_id) || 'NA' }}</td>
                        <td *ngIf="afancy.is_sus == true" colspan="2" class="ballR">Ball Running
                        </td>
                        <td *ngIf="afancy.is_sus == false" class="layyes">{{ afancy.no_odd }} <br> {{ afancy.no_bhav }}
                        </td>
                        <td *ngIf="afancy.is_sus == false" class="backno">{{ afancy.yes_odd }} <br> {{ afancy.yes_bhav
                           }}
                        </td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.runner_name, afancy.id, 'bull', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.runner_name, afancy.id, 'bull', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.runner_name, afancy.id, 'bull', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.selectionId, afancy.runner_name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.runner_name, afancy.id, 'bull', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.selectionId, afancy.runner_name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.id+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
                  <tbody *ngIf="fancyProvider == 'tiger'">
                     <tr *ngFor="let afancy of adata; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ afancy.name }}</td>
                        <td *ngIf="afancy.status1 != 'ACTIVE'" colspan="2" class="ballR">Ball Running
                        </td>
                        <td *ngIf="afancy.status1 == 'ACTIVE'" class="layyes">{{ afancy.l1 }} <br> {{ afancy.ls1 }}
                        </td>
                        <td *ngIf="afancy.status1 == 'ACTIVE'" class="backno">{{ afancy.b1 }} <br> {{ afancy.bs1 }}
                        </td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.name, afancy.id, 'tiger', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.name, afancy.id, 'tiger', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.name, afancy.id, 'tiger', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.selectionId, afancy.name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.name, afancy.id, 'tiger', afancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, matchData.eventId +'-'+ afancy.id+'.FY', afancy.selectionId, afancy.name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="afancy.id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ matchData.eventId +'-'+ afancy.id+'.FY' }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!afancy.id"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ afancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>

         <!--div class="col-md-12 col-xs-12 mtop">
            <h3>Manual Fancy</h3>
         </div-->

         <!--div class="col-md-12 col-xs-12 mtop">
            <div class="table-responsive">
               <table class="table table-bordered">
                  <thead>
                     <tr>
                        <th>#</th>
                        <th>Fancy Name</th>
                        <th class="layyes">No</th>
                        <th class="backno">Yes</th>
                        <th>Action</th>
                        <th>Activities</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let fancy of data; let i = index">
                        <td>{{ i+1 }}</td>
                        <td>{{ fancy.name }}</td>
                        <td *ngIf="fancy.statusLabel != ''" colspan="2" class="ballR">Ball Running</td>
                        <td *ngIf="fancy.statusLabel == ''" class="layyes">{{ fancy.layprice }} <br>{{ fancy.layline }}
                        </td>
                        <td *ngIf="fancy.statusLabel == ''" class="backno">{{ fancy.backprice }}
                           <br>{{ fancy.backline }}</td>
                        <td *ngIf="operation == 'All'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, fancy.fancyid, fancy.name, fancy.runnersid, 'own', fancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="setFancyStatus('Removed', matchData.eventId, fancy.fancyid, fancy.name, fancy.runnersid, 'own', '')"
                              class="btn btn-danger">Remove</button>
                        </td>
                        <td *ngIf="operation == 'Active'">
                           <button
                              (click)="setFancyStatus('Inactive', matchData.eventId, fancy.fancyid, fancy.name, fancy.runnersid, 'own', '')"
                              class="btn btn-danger">Mark Inactive</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, fancy.fancyid, fancy.selectionId, fancy.name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Inactive'">
                           <button
                              (click)="setFancyStatus('Active', matchData.eventId, fancy.fancyid, fancy.name, fancy.runnersid, 'own', fancy)"
                              class="btn btn-danger">Mark Active</button>
                           <button
                              (click)="closePopup('Closed', matchData.eventId, fancy.fancyid, fancy.selectionId, fancy.name)"
                              class="btn btn-danger">Closed</button>
                        </td>
                        <td *ngIf="operation == 'Closed' || operation == 'Removed'">
                        </td>
                        <td>
                           <a *ngIf="fancy.fancyid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ fancy.fancyid }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                           <a *ngIf="!fancy.fancyid"
                              routerLink="/fancy-activities/{{ matchData.eventId }}/{{ fancy.selectionId }}"><button
                                 class="btn btn-info">Show Activities</button></a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div-->
      </div>
   </div>
</div>